import { Box, Grid, Typography } from "@mui/material";
import React, { useMemo } from "react";

import NumberFormats from "components/NumberFormats";
import StockNumber from "components/StockNumber";
import { TRADE_SIDE } from "../../constants";
import { useSearchParams } from "react-router-dom";

function MarketPrices({ coinMarketDetails }) {
  const [searchParams] = useSearchParams();
  const sideId = +searchParams.get("side") || 1;

  const high24h = useMemo(() => {
    if (sideId === TRADE_SIDE.Buy.id) {
      return coinMarketDetails?.high24HourBuy;
    }
    return coinMarketDetails?.high24HourSell;
  }, [sideId, coinMarketDetails]);

  const low24h = useMemo(() => {
    if (sideId === TRADE_SIDE.Buy.id) {
      return coinMarketDetails?.low24HourBuy;
    }
    return coinMarketDetails?.low24HourSell;
  }, [sideId, coinMarketDetails]);

  const change24h = useMemo(() => {
    if (sideId === TRADE_SIDE.Buy.id) {
      return coinMarketDetails?.changePCT24HourBuy;
    }
    return coinMarketDetails?.changePCT24HourSell;
  }, [sideId, coinMarketDetails]);

  return (
    <Grid container>
      <Grid item xs={7}>
        <Typography variant="h3" color="success.main">
          <NumberFormats value={coinMarketDetails?.priceBuy} />
        </Typography>

        <Typography variant="h5" color="error.main">
          <NumberFormats value={coinMarketDetails?.priceSell} />
        </Typography>

        <Box display="flex" alignItems="center" mt={1}>
          <Typography variant="subtitle1" color="text.main" mr={2}>
            Change (24h)
          </Typography>

          <StockNumber
            justifyContent="center"
            variant="subtitle1"
            value={change24h}
            hasArrows
          />
        </Box>
      </Grid>

      <Grid item xs={5}>
        <Grid container>
          <Grid item xs={6}>
            <Typography variant="subtitle2" color="text.main">
              High (24h)
            </Typography>

            <Typography variant="h6" color="text.main">
              <NumberFormats value={high24h} />
            </Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography variant="subtitle2" color="text.main">
              Low (24h)
            </Typography>

            <Typography variant="h6" color="text.main">
              <NumberFormats value={low24h} />
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default MarketPrices;
